export let ExperienceTypes;

(function (ExperienceTypes) {
  ExperienceTypes["Load"] = "load";
  ExperienceTypes["Experience"] = "experience";
  ExperienceTypes["Operation"] = "operation";
})(ExperienceTypes || (ExperienceTypes = {}));

export let ExperiencePerformanceTypes;

(function (ExperiencePerformanceTypes) {
  ExperiencePerformanceTypes["PageLoad"] = "page-load";
  ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
  ExperiencePerformanceTypes["InlineResult"] = "inline-result";
  ExperiencePerformanceTypes["Custom"] = "custom";
})(ExperiencePerformanceTypes || (ExperiencePerformanceTypes = {}));